/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const motivation = useStore((state) => state.motivation);
  const setMotivation = useStore((state) => state.setMotivation);
  const loosGoal = useStore((state) => state.loosGoal);

  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.motivation.title')}</Title>
        <Text className={'description'} size='m' medium>
          {loosGoal === 'Maintain weight and get fit'
            ? t('onboarding.motivation.subTitleWithoutWeightLoss')
            : t('onboarding.motivation.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={motivation}
          onChange={(value: string) => {
            setMotivation(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'motivation',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Vacation'}>
            <span>⛱</span> {t('onboarding.motivation.options.vacation')}
          </Option>
          <Option value={'Wedding'}>
            <span>💍</span> {t('onboarding.motivation.options.wedding')}
          </Option>
          <Option value={'Sport'}>
            <span>🏆</span> {t('onboarding.motivation.options.sport')}
          </Option>
          <Option value={'Summer'}>
            <span>🌞</span> {t('onboarding.motivation.options.summer')}
          </Option>
          <Option value={'School'}>
            <span>🎒</span> {t('onboarding.motivation.options.school')}
          </Option>
          <Option value={'Party'}>
            <span>🎉</span> {t('onboarding.motivation.options.party')}
          </Option>
          <Option value={'Pregnant'}>
            <span>🤰</span> {t('onboarding.motivation.options.pregnant')}
          </Option>
          <Option value={'No'}>
            <span>🙅‍♀</span> {t('onboarding.motivation.options.no')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
